/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 16/07/2019.
 *
 * Version : Generator 2.0.9
 */

import {ErrorHandler, NgModule} from '@angular/core';
import {MoMomentPipe, MoSafeUrlPipe, MoSafeHtmlPipe} from './pipe';
import {MoMediaSrcCacheDirective, MoPdfSrcCacheDirective, MoVideoSrcCacheDirective} from './directive';
import {MoPictureComponent, MoSignatureComponent, PinchZoomModule} from './component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {MpaService} from './mpa';
import {MsaService} from './msa';
import {ConfigService, CordovaBackService, CordovaUIService, MoI18nService} from './service';
import {PinchZoomComponent} from './component/pinch-zoom/pinch-zoom.component';
import {BrowserModule} from '@angular/platform-browser';
import {WebpackTranslateLoader} from './utility/webpackTranslateLoader';
import {ToastrModule} from 'ngx-toastr';
import {GeoService} from './geo';
import {LogService} from './log';
import {LogErrorsHandler} from './log/logErrorsHandler';
import {AuthGuard} from '../app/services/authGuard';
import {SignaturePadModule} from 'angular2-signaturepad';

@NgModule({
    declarations: [
        MoMomentPipe,
        MoMediaSrcCacheDirective,
        MoVideoSrcCacheDirective,
        MoPdfSrcCacheDirective,
        MoPictureComponent,
        MoSignatureComponent,
        MoSafeUrlPipe,
        MoSafeHtmlPipe,
    ],
    imports     : [
        BrowserModule,
        TranslateModule.forRoot({
            loader: {
                provide : TranslateLoader,
                useClass: WebpackTranslateLoader
            }
        }),
        PinchZoomModule,
        ToastrModule.forRoot(),
        SignaturePadModule
    ],
    exports        : [
        PinchZoomComponent,
        MoMomentPipe,
        MoMediaSrcCacheDirective,
        MoVideoSrcCacheDirective,
        MoPdfSrcCacheDirective,
        MoPictureComponent,
        MoSignatureComponent,
        MoSafeUrlPipe,
        MoSafeHtmlPipe,
        TranslateModule
    ],
    providers   : [
        MpaService,
        MsaService,
        MoI18nService,
        CordovaUIService,
        CordovaBackService,
        ConfigService,
        GeoService,
        LogService,
        LogErrorsHandler,
        {
            provide: ErrorHandler,
            useClass: LogErrorsHandler,
        }
    ]
})
export class MoModule {
}
